module.exports = __webpack_public_path__ + "static/media/fail_prize.53a31c9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/fail_prize.png
// module id = 1463
// module chunks = 0